import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-browser-support',
  template: ''
})
export class BrowserSupportComponent implements OnInit {
  deviceInfo = null;

  constructor(
    public deviceService: DeviceDetectorService
  ) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
  }

  ngOnInit(): void {
    if (this.deviceInfo && this.deviceInfo.browser === 'IE') {
      window.location.href = '/unsupported-browser.html';
    }
  }
}
